import { TagDto } from './tag.dto';

/**
 * Tipos de solicitud de gastos adicionales
 */
export type AdditionalCostRequestType =
  | 'TAXI'
  | 'BLABLACAR'
  | 'TRAIN'
  | 'PLANE'
  | 'TOLL'
  | 'FUEL'
  | 'MEALS'
  | 'LODGING'
  | 'WAITING_TIME'
  | 'ELECTRIC_VEHICLE_CHARGING_TIME'
  | 'ADBLUE'
  | 'OIL'
  | 'FERRY'
  | 'OTHER';

/**
 * Estados de solicitud de gastos adicionales
 */
export type AdditionalCostRequestStatus =
  | 'NEW'
  | 'PENDING_TICKET'
  | 'EXPIRED'
  | 'PENDING_VALIDATION'
  | 'VALIDATED'
  | 'REQUEST_REJECTED'
  | 'TICKET_REJECTED';

/**
 * DTO para datos del conductor dentro de gastos adicionales
 */
export interface AdditionalCostDriverDto {
  id: number;
  email: string;
  phone: string;
  name: string;
  last_name: string;
  dni: string;
  cif: string;
  rating: string;
  tags: number[] | TagDto[];
}

/**
 * DTO para gastos adicionales
 */
export class AdditionalCostDto {
  id: number = 0;
  amount_requested: number = 0;
  amount_quoted: number | null = null;
  comments: string = '';
  admin_comments: string = '';
  ticket: string | null = null;
  vehicle_frame_photo: string | null = null;
  rejection_reason: string = '';
  ticket_rejection_reason: string = '';
  request_status: AdditionalCostRequestStatus = 'NEW';
  request_type: AdditionalCostRequestType = 'OTHER';
  request_date: string = '';
  ticket_uploaded_date: string | null = null;
  approved_date: string | null = null;
  rejected_date: string | null = null;
  invoiced: boolean = false;
  transport_id: number | null = null;
  driver: AdditionalCostDriverDto | null = null;
  approved_by: number | null = null;
  rejected_by: number | null = null;
  created_date: string = '';
  modified_date: string = '';
  can_upload_ticket: boolean = false;
  is_within_courtesy_period: boolean = false;
  requires_ticket: boolean = false;
  requires_vehicle_frame_photo: boolean = false;

  constructor(data?: Partial<AdditionalCostDto>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  /**
   * Crear instancia desde JSON del backend
   */
  static fromJson(json: any): AdditionalCostDto {
    return new AdditionalCostDto(json);
  }
}

/**
 * Interfaz para respuesta paginada de gastos adicionales
 */
export interface PaginatedAdditionalCostsResponse {
  count: number;
  total_pages?: number;
  next: string | null;
  previous: string | null;
  results: AdditionalCostDto[];
  pending_manage: number;
  pending_ticket: number;
}

/**
 * Interfaz para tipos de rechazo de gastos adicionales
 */
export interface AdditionalCostRejectionType {
  code: string;
  label: string;
  message: string;
}

/**
 * Interfaz para detalle de un gasto adicional (GET /additional-costs/{id}/)
 */
export interface AdditionalCostDetailDto {
  id: number;
  amount_requested: number;
  amount_quoted: number | null;
  comments: string;
  admin_comments: string;
  ticket: string | null;
  vehicle_frame_photo: string | null;
  rejection_reason: string;
  ticket_rejection_reason: string;
  request_status: AdditionalCostRequestStatus;
  request_type: AdditionalCostRequestType;
  request_date: string;
  ticket_uploaded_date: string | null;
  approved_date: string | null;
  rejected_date: string | null;
  not_invoiceable: boolean | null;
  invoiced: boolean;
  driver: number;
  driver_name: string;
  transport: number;
  approved_by: number | null;
  rejected_by: number | null;
  created_date: string;
  modified_date: string;
  can_upload_ticket: boolean;
  is_within_courtesy_period: boolean;
  requires_ticket: boolean;
  requires_vehicle_frame_photo: boolean;
  vat_percentage: number;
}
